import React, { useState } from "react";
import { useLocation, useSearchParams } from "react-router-dom";

import PostLoginLayout from "../components/layouts/PostLoginLayout";
import RedirectComponent from "../components/RedirectComponent";

const Redirect = () => {
  const [loader, setLoader] = React.useState(true);

  function onLoaderExit(): void {
    setLoader(false);
  }

  let RedirectContainer = <RedirectComponent onLoaderExit={onLoaderExit} />;

  return (
    <PostLoginLayout
      childComponent={RedirectContainer}
      noLeftPanel={false}
      loader={loader}
    />
  );
};

export default Redirect;
